
import { useContent, useOnScrollHidden } from "@/hooks";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "MobileNav",
  setup() {
    const hidden = ref(true);
    const { links } = useContent();

    useOnScrollHidden(hidden, 120);

    return { links, hidden };
  },
});
